import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { UserProfile } from 'src/app/core/models/user-profile';
import { SidebarService } from 'src/app/core/services/sidebar.service';
import { Constant } from '../../constants';
import { AuthService } from "../../../core/services/auth/auth.service";
import { ConfigService } from "../../../core/services/config/config.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent implements OnInit {
  isPage = '';
  permission = '';
  userProfile!: UserProfile;
  headMenu = 'เลือกรายการที่ต้องการ';
  isSidebarVisible = true;
  listMenu!: any;
  events: string[] = [];
  opened: boolean = true;
  menuClassMobile = '';
  isElectronicTaxEnabled = false;

  constructor(
    private router: Router,
    private constant: Constant,
    private _snackBar: MatSnackBar,
    private authService: AuthService,
    private configService: ConfigService,
    public sidebarService: SidebarService
  ) {
    this.loadConfig();

    // ตรวจสอบการเปลี่ยนแปลง sidebar visibility
    this.sidebarService.sidebarVisibilityChange.subscribe((value) => {
      this.isSidebarVisible = value;
      console.log('SidebarComponent: sidebarVisibilityChange', value);
    });

    this.sidebarService.sidebarToggleChange.subscribe((value) => {
      this.menuClassMobile = value ? 'opened' : '';
    });
  }

  ngOnInit() {
    window.scrollTo(0, 0);

    // ตรวจสอบค่าจริงของ isSidebarVisible เมื่อ component โหลด
    console.log('SidebarComponent Init: isSidebarVisible =', this.sidebarService.isSidebarVisible);

    // เรียกดูข้อมูลผู้ใช้
    try {
      this.userProfile = this.authService.getUserProfile();
      console.log('User profile loaded:', this.userProfile);
    } catch (error) {
      console.error('Error loading user profile:', error);
    }

    const page = window.location.href.split('/');
    this.isPage = page[page.length - 1];

    // ดึงค่า permission จาก session storage
    try {
      this.permission = this.authService.getSessionStorage('permission');
      console.log('Permission loaded:', this.permission);
    } catch (error) {
      console.error('Error loading permission:', error);
    }

    this.onCheckPermission(this.permission);

    // ต้องมั่นใจว่า sidebar มองเห็นได้เมื่อโหลด component
    this.sidebarService.toggleSidebarVisibility(true);
  }

  /**
   * โหลดค่า config จาก ConfigService
   */
  loadConfig() {

    return this.configService.getConfig()
      .then((response) => {
        if (response) {
          this.isElectronicTaxEnabled = response.enable;
          this.setItems();
        }
        console.log('loading config...', response.enable);
        return response;
      })
      .catch((error) => {
        console.error('Error loading config:', error);
        this.isElectronicTaxEnabled = false; // Default to false if error
        this.setItems();
        return null;
      });
  }

  setItems() {
    // ดึงรายการเมนูจาก constant
    const fullMenuList = this.constant.LIST_MENU;

    // กรองรายการเมนูที่เกี่ยวข้องกับการหักภาษี ณ ที่จ่าย หากการตั้งค่าปิดอยู่
    if (!this.isElectronicTaxEnabled) {
      this.listMenu = fullMenuList.filter(item =>
        !item.path.includes('TransactionPdf') &&
        !item.name.includes('หลักฐานรับรองการหักภาษี ณ ที่จ่าย แบบอิเล็กทรอนิกส์')
      );
    } else {
      this.listMenu = fullMenuList;
    }
  }

  onCheckPermission(_value: string | null) {
    if (!_value) {
      this._snackBar.open('กรุณาเข้าสู่ระบบ', '', {
        panelClass: '_warning',
      });
      window.location.replace('./');
    }
  }

  onActive(page: string) {
    this.router.navigate([page]);
    console.log('Navigate to:', page);

    this.listMenu.forEach((element: { active: boolean; }) => {
      element.active = false;
    });

    const activeItem = this.listMenu.find((item: { path: string; role: string; }) =>
      item.path === page && item.role === this.permission
    );

    if (activeItem) {
      activeItem.active = true;
    }
  }

  logout() {
    this.authService.clearSessionStorage('permission');
    this._snackBar.open('ออกจากระบบสำเร็จ', '', {
      panelClass: '_success',
    });
    window.location.replace('./');
  }

  mainPage() {
    window.location.replace('./main');
  }

  toggleSideBar(flag: boolean) {
    console.log('toggleSideBar called with:', flag);
    this.sidebarService.toggleSidebarVisibility(flag);
  }

  trackById(index: number, item: any): number {
    return index;
  }
}
